import { useMutation, useQuery } from 'react-query';
import type { UseMutationOptions, UseQueryOptions } from 'react-query';

import type {
  PortalSupplyContract,
  SupplyContractCreateData,
} from '@portal/api-models';

import { client } from '../client';
import { QueryKey } from '../types';

interface GetSupplyContractsQuery {
  id?: number;
  limit?: number;
  offset?: number;
  subAccountUuid?: string;
}

const baseUrl = '/finance/supply-contracts';

export const getSupplyContracts = async (params?: GetSupplyContractsQuery) =>
  client
    .get<PortalSupplyContract[]>(baseUrl, { params })
    .then(({ data }) => data);

export const createSupplyContract = async (data: SupplyContractCreateData) =>
  client.post<PortalSupplyContract>(baseUrl, data).then(({ data }) => data);

export const deleteSupplyContract = async (supplyContractId: number) =>
  client
    .delete<void>(`${baseUrl}/${supplyContractId}`)
    .then(({ data }) => data);

export const useGetSupplyContractsQuery = (
  params?: GetSupplyContractsQuery,
  options?: Omit<
    UseQueryOptions<PortalSupplyContract[]>,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery(
    [QueryKey.SupplyContracts, params],
    async () => getSupplyContracts(params),
    options
  );

export const useCreateSupplyContractMutation = (
  options?: UseMutationOptions<
    PortalSupplyContract,
    unknown,
    SupplyContractCreateData
  >
) => useMutation(createSupplyContract, options);

export const useDeleteSupplyContractMutation = (
  options?: UseMutationOptions<void, unknown, number>
) => useMutation(deleteSupplyContract, options);
